import type { ReactNode } from 'react';
import type { PortalReportSectionId } from '../../../../types/portalReport';

// CLIENT PORTAL Phase 1 — the composable section renderer.
//
// ⚠️⚠️ PAGES DO NOT HARDCODE THEIR LAYOUT. Each page hands this a MAP of section
// id → renderer, and the ORDER comes from the per-brand config. Scott: *"the
// report for each Brand will be slightly different and connected to different
// BigQuery sources for CRM data."*
//
// ⚠️ A section id with NO renderer is SKIPPED, not an error. That is what makes
// the `crm` slot free: it is already in the vocabulary, absent from every v1
// config, and the day a brand's config asks for it the page renders it as soon
// as a renderer exists — with no page rewrite and no crash in the meantime if
// the two land out of order.

export type SectionRenderers = Partial<Record<PortalReportSectionId, () => ReactNode>>;

export function ReportSections({
  order,
  renderers,
}: {
  order: readonly PortalReportSectionId[];
  renderers: SectionRenderers;
}) {
  return (
    <div className="space-y-8">
      {order.map((id) => {
        const render = renderers[id];
        if (!render) return null;
        const content = render();
        if (content == null) return null;
        return <div key={id}>{content}</div>;
      })}
    </div>
  );
}
